import { render, staticRenderFns } from "./SelfPublishing.vue?vue&type=template&id=78283029&scoped=true&"
import script from "./SelfPublishing.vue?vue&type=script&lang=js&"
export * from "./SelfPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78283029",
  null
  
)

export default component.exports